
import { defineComponent } from 'vue'
import { ColorEnum } from '../../../enums'

import { EpbText } from '../../shared/epb-text'
import { OriginsStepEnum } from './origins.component'

export default defineComponent({
  name: 'OriginsStep',
  components: { EpbText },
  props: {
    step: {
      type: Number,
      required: true,
    },
    messages: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      ColorEnum,
    }
  },
  computed: {
    color(): ColorEnum {
      return (
        {
          [OriginsStepEnum.DEFAULT]: () => ColorEnum.NEUTRAL_25,
          [OriginsStepEnum.PREDICTIVE]: () => ColorEnum.OCEAN_75,
          [OriginsStepEnum.REFINEMENT]: () => ColorEnum.YELLOW_75,
        }[this.step] as () => ColorEnum
      )()
    },
  },
})
